/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSummaryModel } from '../../models/patient-summary-model';

export interface ConsumerPatientSummaryPost$Params {
      body?: PatientSummaryModel
}

export function consumerPatientSummaryPost(http: HttpClient, rootUrl: string, params?: ConsumerPatientSummaryPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<PatientSummaryModel>> {
  const rb = new RequestBuilder(rootUrl, consumerPatientSummaryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<PatientSummaryModel>;
    })
  );
}

consumerPatientSummaryPost.PATH = '/Consumer/PatientSummary';
